// extracted by mini-css-extract-plugin
export default {"wrapper":"LegalPageContent_wrapper__sUCvZ","sidebar":"LegalPageContent_sidebar__AMZMQ","content":"LegalPageContent_content__9SPmW"};